var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"close lightboxClose",attrs:{"href":"#!"}},[_c('i',{staticClass:"fas fa-times-circle"})])
}]

export { render, staticRenderFns }